/**
 * Marketing-doc uids whose hero embeds the CMMC demo HubSpot form (MAR-5406 batch).
 * Membership drives demo conversion tracking: `demoEmbeddedForm` type in HeroForm
 * (fires 'Demo Requested' instead of the ebook default) and the CMMC ChiliPiper
 * router + label rewrites in HubSpotForm.
 */
export const CMMC_DEMO_FORM_UIDS: readonly string[] = [
  'request-cmmc-demo',
  'cmmc-compliance-services',
  'cmmc-enclave',
  'cmmc-2-0',
  'what-is-cmmc',
  'cmmc-level-2',
  'cmmc-certification',
  'compare-summit7',
  'compare-preveil',
  'fall-gift',
]
